import styled from 'styled-components';
import { SELECTORS, UBISOFT_BLUE } from '../../constants';

//Sets page max width
export const Container = styled.div`
    ${SELECTORS} & {
        width: 90%;
        max-width: 1430px;
        display: block;
        margin: 0 auto;
    }
`;

export const BackgroundImageContainer = styled.div`
    ${SELECTORS} & {
        width: 100%;
        height: 80vh;
        img{
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }
`;

export const PageInformationCenter = styled.div`
    ${SELECTORS} & {
        position: absolute;
        width: 100%;
        height: 80vh;
        top: 0;
        left: 0;
        background: rgba(32, 35, 39, 0.9);
    }
`;

export const LargeContainer = styled.div`
    ${SELECTORS} & {
        width: 100%;
        display: block;
        margin: 0 auto;
        background-color: #1f2226;
    }
`;

export const PageBackground = styled.div`
    ${SELECTORS} & {
        background: linear-gradient(202deg, #428ee0 -25%, #1f2226 60%);
        height: 100%;
        width: 100%;
    }
`;

export const PageBackgroundContainer = styled.div`
    ${SELECTORS} & {
        bottom: 0;
        left: 0;
        position: fixed;
        right: 0;
        top: 0;
        z-index: -9999;
    }
`;
